type ParticipantsCounterProps = {
  count: number;
};

export function ParticipantsCounter({ count }: ParticipantsCounterProps) {
  return (
    <span className="inline-flex items-center">
      <span className="inline-flex size-6 items-center justify-center rounded-full border border-input bg-border text-xs text-foreground">
        {count}
      </span>
    </span>
  );
}
